import { Box, ChakraProvider, Spinner, Text, VStack } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import GranaTech from "./routes/GranaTech";
import {
  useWhiteLabelStore,
} from "./contexts/whiteLabelContext";
import { getSlugFromUrl } from "./utils/getSlugFromUrl";
import { fetchWhiteLabel } from "./services/whiteLabel.service";
import createTheme from "./theme/theme";
import { useSetBrowserPage } from "./contexts/useSetBrowserPage";

export default function App() {
  const [isLoading, setIsLoading] = useState(true);
  const { setWhiteLabel } = useWhiteLabelStore();
  const getAssets = useWhiteLabelStore((state) => state.getAssets);
  const slug = getSlugFromUrl();

  useEffect(() => {
    const loadWhiteLabel = async () => {
      setIsLoading(true);
      try {
        const data = await fetchWhiteLabel(slug);
        setWhiteLabel(data);
      } catch (error) {
        console.error("Error loading white label data:", error);
        setWhiteLabel(null);
      } finally {
        setIsLoading(false);
      }
    };

    loadWhiteLabel();

  }, [setWhiteLabel, slug]);

  const { favicon, name } = getAssets();
  useSetBrowserPage(favicon, name);

  const theme = createTheme();

  if (isLoading) {
    return (
      <ChakraProvider theme={theme}>
        <Box
          height="100vh"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <VStack spacing={4}>
            <Spinner size="xl" color="primary" thickness="4px" speed="0.65s" />
            <Text fontSize="xl" fontWeight="medium">
              Carregando...
            </Text>
          </VStack>
        </Box>
      </ChakraProvider>
    );
  } else {
    return (
      <ChakraProvider theme={theme}>
        <GranaTech />
      </ChakraProvider>
    );
  }
}
